import classnames from 'classnames/bind'
import React from 'react'
import { GlobalThemeColors } from '~/@types/colors'

import { LinkProps } from '@unlikelystudio/react-abstract-components'

import { RichTextBlock } from '~/components/Abstracts/RichText'
import SectionTitle from '~/components/Account/Logged/SectionTitle'
import SquaredCta from '~/components/UI/SquaredCta'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type EmptySectionProps = {
  className?: string
  title?: RichTextBlock
  link?: LinkProps
  isOrderSection?: boolean
  onClick?: (e: React.MouseEvent) => void
}

function EmptySection({ className, link, title }: EmptySectionProps) {
  return (
    <div className={cx(css.EmptySection, className)}>
      <SectionTitle className={css.title} title={title} />
      {link && (
        <SquaredCta
          className={cx(css.cta)}
          theme={GlobalThemeColors.Black}
          withBackground
          {...link}
        />
      )}
    </div>
  )
}

EmptySection.defaultProps = {}

export default EmptySection
